import { Icon } from "@mui/material";


const PauseScreen = ({ handleTogglePause }) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "24px 16px",
        margin: "0",
        width: "100%",
        maxHeight: "100%",
        backgroundColor: "#f8f9fa",
        borderRadius: "12px",
        border: "2px dashed #0e5489",
        textAlign: "center",
        boxSizing: "border-box",
        overflow: "hidden",
      }}
    >
      <Icon style={{ fontSize: 48, color: "#0e5489", marginBottom: 12 }}>
        pause_circle_filled
      </Icon>

      <h3
        style={{
          color: "#0e5489",
          fontWeight: 600,
          marginBottom: 6,
          fontSize: "1.25rem",
        }}
      >
        PRACA WSTRZYMANA
      </h3>

      <p
        style={{
          color: "#6c757d",
          maxWidth: "400px",
          marginBottom: 16,
          fontSize: "0.85rem",
        }}
      >
        Zlecenie znajduje się obecnie w stanie pauzy. Aby edytować pola lub
        kontynuować realizację, należy najpierw wznowić pracę.
      </p>

      <button
        type="button"
        onClick={handleTogglePause}
        style={{
          backgroundColor: "#0e5489",
          color: "#fff",
          border: "none",
          borderRadius: "8px",
          padding: "10px 24px",
          fontSize: "0.95rem",
          fontWeight: "600",
          cursor: "pointer",
          boxShadow: "0 4px 12px rgba(14, 84, 137, 0.25)",
          transition: "all 0.2s ease",
          display: "flex",
          alignItems: "center",
          gap: "8px",
        }}
      >
        <Icon>play_arrow</Icon>
        Wznów pracę
      </button>
    </div>
  );
};

export default PauseScreen;
